import { useState } from "react";
import { fetchVisitsSummary } from "../../utils/patients/fetchVisitsSummary";
import useProfileStore from "../../store/patient/profileStore";
const useManageVisits = () => {

  const [loading, setLoading] = useState(false);
  const [Visits, setVisits] = useState();
  const {profile} = useProfileStore()

  

  // id = 27503
  const handleFetchVisitsSummary = async () => {
    setLoading(true);
    await fetchVisitsSummary(profile?.id)
    .then((res) => {
        setLoading(false);
        setVisits(res?.data);
      })
      .catch((err) => {
        window.location.href = "/pages/signin2";
        console.log("error error");
        setLoading(false);
      });
  };



  return {
    handleFetchVisitsSummary,
    Visits,
    setVisits,
    loading,
  };
};

export default useManageVisits;